import axios from 'axios';

// Selection tokens are not application sessions. Keep their 401/403 responses
// local to SelectStore; never install the application session interceptor here.
const organizationSelectionApi = axios.create();
organizationSelectionApi.interceptors.request.use(request => {
  const language = axios.defaults.headers.common['Accept-Language'];
  if (language) request.headers['Accept-Language'] = language;
  return request;
});

export { organizationSelectionApi };
